/* eslint-disable no-restricted-globals */

const workerCode = () => {
    let interval;

    self.addEventListener('message', (e) => {
        switch(e.data) {
            case 'start':
                clearInterval(interval);
                interval = setInterval(() => {
                    self.postMessage('tick');
                }, "INTERVAL_MS");
                break;
            case 'stop':
                clearInterval(interval);
                break;
            default:
                break;
        }
    }, false);
}

const ticker = (intervalMS = 1000, intervalName = undefined) => {
    let code = workerCode.toString();
    code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
    code = code.replace("INTERVAL_MS", intervalMS);
    code = code.replaceAll("INTERVAL_NAME", intervalName);

    const blob = new Blob([code], {type: "application/javascript"});
    return URL.createObjectURL(blob);
}

export default ticker;